
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connectivity-issues",
      function () {
        return require("private-next-pages/connectivity-issues.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connectivity-issues"])
      });
    }
  